export default __webpack_public_path__ + "static/duo-wide-1280-772ef095bf7ff4ad5786861366dfe89b.jpg";